// import { Route } from "@lernetz/ui-components/src/router/Route";
import { Route } from "@lernetz/ui-components/src/router/Route";
import { Router as BaseRouter } from "@lernetz/ui-components/src/router/Router";
import { Segment, Stack } from "@lernetz/ui-components/src/stack/Stack";
import GoodPracticeModule from "../good-practice/good-practice.module";
import {ToolModule} from "../tool/tool.module";
// import {WizardRootSegment} from "../components/wizard/Wizard";
import { gateway } from "./gateway";
import {trackEvent} from "./tracker";
import {languageService} from "./lang";
import {WizardSegment} from "../components/wizard/wizard.segment";

import {HomeController} from "../pages/Home";
import {ResultPageController} from "../pages/results/results.component";
import {SearchPageController} from "../pages/search/search";
import {MissingPageController} from "../pages/Missing";
import {GenericPageController} from "../pages/generic/generic.component";

const routes = [
    new Route({
        pattern: "/",
        name: "home",
        // caching: true,
        content: () => {
            const data = {
                feeds: []
            } as any;

            languageService.correctUrl();
            return { view: "Home", data: new HomeController() };
        },
    }),
    new Route({
        pattern: "/:lang/home/:topicSlug",
        name: "home",
        // caching: true,
        content: () => {
            const data = {
                feeds: []
            } as any;
            return { view: "Home", data: new HomeController() };
        },
    }),
    ...GoodPracticeModule.routes,
    ...ToolModule.routes,
    new Route({
        name: "search",
        pattern: "/:lang/search",
        content: (params, route) => {
            let data = new SearchPageController()

            return {
                view: "SearchPage",
                data,
            };
        },
    }),
    new Route({
        name: "page",
        pattern: "/:lang/p/:slug",
        content: (params, route) => {
            const data = new GenericPageController();
            data.routeInit(params.slug);

            return {
                view: "GenericPage",
                data,
            };
        },
    }),
    new Route({
        name: "wizard",
        pattern: "/:lang/wizard",
        content: (params, route) => {
            const component = {
                view: "WizardStart",
                data: {
                },
            };
            gateway
                .loadInitialWizardQuestion()
                .then((wq) => {
                    Object.assign(component.data, wq)
                });

            return component;
        },
    }),
    new Route({
        name: "results",
        pattern: "/:lang/result/:query",
        content: (params, route) => {
            const resultController = new ResultPageController(params.lang);
            // resultController.routeInit(params.query);
            return {
                view: "ResultPage",
                data: resultController
            };
        },
    }),
    new Route({
        pattern: "/:lang",
        name: "home",
        // caching: true,
        content: (params) => {
            // backend renders normal frontapge when wrong lang-prefix are used
            if (['en', 'de'].includes(params.lang)) {
                return { view: "Home", data: new HomeController() };
            } else if (params.lang === 'index.php?id=tools') {
                // old bookmarks are stored with this
                return { view: "Home", data: new HomeController() };
            } else {
                trackEvent("404", { url: window.location.href, referrer: document.referrer })
                return { view: "Missing", data: new MissingPageController() };
            }
        },
    }),
];

export class WizardRootSegment implements Segment {
    view: string = "Wizard";
    data = {} as any;
    currentLang: string;
    url: '';

    constructor() {
        this.currentLang = languageService.currentLang;
    }

    async resolve(urlSeg: string) {
        this.data = await gateway.get(urlSeg);
        this.data.level = 0;
        return new WizardSegment(this.data);
    }
}

export const wizardStack = {
    de: new Stack({
        name: "wizardStep",
        pattern: "/de/wizard/*",
        root: new WizardRootSegment(),
    }),
    en: new Stack({
        name: "wizardStep",
        pattern: "/en/wizard/*",
        root: new WizardRootSegment(),
    })
};

class Router extends BaseRouter {
    toPath( path: string ) {
        super.toPath(path);
        resetScrollPosition();
    }
}

export const router = new Router({
    routes: [
        ...routes,
        ...Object.values(wizardStack).map( s => s.route),
        // enStack.route,
        new Route({
            pattern: "/*",
            name: "404",
            // caching: true,
            content: () => {
                // gateway.loadInitialWizardQuestion().then( wizardSteps => data.wizardSteps = wizardSteps);
                trackEvent("404", { url: window.location.href, referrer: document.referrer })
                return { view: "Missing", data: new MissingPageController() };
            },
        }),
    ],
});

function resetScrollPosition() {
    // window.scrollTo(0, 0);
    const el = document.getElementById("scroll-container");
    if (el) {
        // el.scrollTo( { behavior: "smooth", top: 0, left: 0 } );
        el.scrollTo(0,0);
    }
}

export function toRoute(urlName: string, params?) {
    router.toRoute(urlName, { lang: languageService.currentLang, ...params});
}
